// Bilingual dictionary for Litterantara (ID default, EN toggle)
export const translations = {
  id: {
    lang: { switchTo: "EN", current: "ID" },
    nav: {
      home: "Beranda",
      about: "Tentang Kami",
      solutions: "Solusi",
      cases: "Studi Kasus",
      insights: "Wawasan",
      portal: "Ekosistem Klien",
      contact: "Konsultasi",
      cta: "Jadwalkan Audit AI",
    },
    brand: { tagline: "Kecerdasan Terukur, Solusi Terstruktur" },
    footer: {
      blurb:
        "Konsultan & integrator implementasi AI skala enterprise. Kami menjembatani kompleksitas AI dengan kebutuhan operasional korporasi Anda.",
      nav: "Navigasi",
      ecosystem: "Ekosistem",
      contactTitle: "Hubungi Kami",
      rights: "Seluruh hak cipta dilindungi.",
      built: "Dirancang untuk perusahaan yang menuntut presisi.",
    },
    marquee: [
      "LLM Integration",
      "Predictive Analytics",
      "Computer Vision",
      "Process Automation",
      "MLOps Governance",
      "Data Security",
      "Enterprise ROI",
      "Kecerdasan Terukur",
    ],
    home: {
      heroEyebrow: "Enterprise AI Integrator",
      heroLine1: "Kecerdasan Terukur.",
      heroLine2: "Solusi Terstruktur.",
      heroSub:
        "Litterantara merancang, membangun, dan mengelola implementasi AI enterprise yang aman, presisi, dan berorientasi ROI nyata — bukan eksperimen, melainkan infrastruktur.",
      heroCta: "Jadwalkan Audit AI Awal",
      heroCta2: "Jelajahi Solusi",
      statClients: "Modul AI Terintegrasi",
      statUptime: "SLA Ketersediaan",
      statRoi: "Rata-rata ROI Klien",
      // Value proposition
      valueEyebrow: "01 — Mengapa Litterantara",
      valueTitle: "Solusi umum menjawab tren. Solusi kustom menjawab bisnis Anda.",
      valueBody:
        "AI generik menghasilkan demo yang mengesankan namun rapuh di lingkungan produksi enterprise. Kami membangun sistem yang menyatu dengan alur kerja, kepatuhan, dan tata kelola data korporasi Anda.",
      genericTitle: "Solusi AI Umum",
      generic: [
        "Model kotak-hitam tanpa konteks bisnis",
        "Integrasi rapuh dengan sistem legacy",
        "Tidak ada jaminan keamanan & kepatuhan data",
        "ROI yang tidak terukur",
      ],
      customTitle: "Pendekatan Litterantara",
      custom: [
        "Arsitektur AI dirancang untuk domain Anda",
        "Middleware integrasi ke ERP, CRM, & data warehouse",
        "Keamanan enterprise-grade & tata kelola penuh",
        "KPI dan ROI terukur pada setiap fase",
      ],
      // Services
      servicesEyebrow: "02 — Layanan Inti",
      servicesTitle: "Empat pilar implementasi AI enterprise.",
      services: [
        {
          tag: "LLM",
          title: "LLM Integration",
          desc: "Asisten domain-spesifik, RAG di atas basis pengetahuan korporasi, dan otomasi dokumen yang aman di balik firewall Anda.",
        },
        {
          tag: "ANALYTICS",
          title: "Predictive Analytics",
          desc: "Model peramalan permintaan, deteksi anomali, dan optimasi keputusan yang menyatu dengan data warehouse Anda.",
        },
        {
          tag: "VISION",
          title: "Computer Vision",
          desc: "Inspeksi kualitas, OCR dokumen, dan pemantauan visual real-time untuk operasi industri dan logistik.",
        },
        {
          tag: "AUTOMATION",
          title: "Process Automation",
          desc: "Orkestrasi alur kerja cerdas yang menggabungkan RPA, LLM, dan aturan bisnis untuk efisiensi operasional.",
        },
      ],
      // Security
      securityEyebrow: "03 — Keamanan & Kepatuhan",
      securityTitle: "Infrastruktur yang layak dipercaya data paling sensitif Anda.",
      securityBody:
        "Setiap deployment dibangun di atas prinsip zero-trust, enkripsi menyeluruh, dan isolasi data. Data enterprise Anda tidak pernah meninggalkan perimeter yang Anda kendalikan.",
      badges: ["ISO 27001", "SOC 2 Ready", "GDPR", "UU PDP", "Zero-Trust", "End-to-End Encryption"],
      stackTitle: "Stack Teknologi",
      stack: [
        { n: "WordPress / SitePad", d: "Front-end marketing & media" },
        { n: "Laravel", d: "Portal klien & middleware API" },
        { n: "Nextcloud", d: "Manajemen dokumen rahasia" },
        { n: "RainLoop", d: "Webmail support enterprise" },
        { n: "Mautic", d: "Marketing automation & CRM" },
      ],
      // Case studies
      caseEyebrow: "04 — Studi Kasus",
      caseTitle: "Dampak terukur di lini depan operasi.",
      caseNote: "*Simulasi ilustratif berdasarkan pola engagement enterprise.",
      cases: [
        {
          sector: "Manufaktur",
          metric: "-38%",
          label: "Cacat produksi",
          desc: "Computer vision untuk inspeksi kualitas real-time pada lini perakitan.",
        },
        {
          sector: "Perbankan",
          metric: "4.2x",
          label: "Kecepatan proses klaim",
          desc: "LLM + RAG untuk otomasi review dokumen dan kepatuhan.",
        },
        {
          sector: "Ritel",
          metric: "+21%",
          label: "Akurasi peramalan",
          desc: "Predictive analytics untuk optimasi inventori multi-gudang.",
        },
      ],
      // CTA
      ctaEyebrow: "Langkah Berikutnya",
      ctaTitle: "Mulai dengan audit AI yang tidak mengikat.",
      ctaBody:
        "Dalam 45 menit, tim arsitek kami memetakan peluang AI berdampak tertinggi di organisasi Anda beserta estimasi ROI-nya.",
      ctaBtn: "Jadwalkan Sekarang",
    },
    about: {
      heroEyebrow: "Tentang Litterantara",
      heroTitle: "Kami membangun kecerdasan yang bertanggung jawab pada hasil.",
      heroSub:
        "Litterantara berdiri di persimpangan riset AI dan realitas operasional korporasi. Kami menerjemahkan potensi AI menjadi sistem yang aman, terukur, dan berkelanjutan.",
      visionTitle: "Visi",
      visionBody:
        "Menjadi mitra integrasi AI enterprise paling tepercaya di Asia Tenggara — di mana setiap implementasi menghasilkan nilai bisnis yang dapat dibuktikan.",
      missionTitle: "Misi",
      missionBody:
        "Menghadirkan solusi AI yang menyatu dengan tata kelola, keamanan, dan tujuan strategis korporasi, melalui metodologi yang disiplin dan transparan.",
      methodEyebrow: "Metodologi Kerja",
      methodTitle: "Empat fase. Nol kejutan.",
      method: [
        {
          n: "01",
          title: "Discovery",
          desc: "Kami memetakan proses, data, dan tujuan bisnis Anda untuk mengidentifikasi peluang AI berdampak tertinggi.",
        },
        {
          n: "02",
          title: "Blueprint",
          desc: "Arsitektur teknis, model keamanan, dan roadmap implementasi dirancang dengan estimasi ROI yang jelas.",
        },
        {
          n: "03",
          title: "Execution",
          desc: "Pengembangan, integrasi, dan deployment iteratif dengan validasi berkelanjutan di setiap milestone.",
        },
        {
          n: "04",
          title: "Governance",
          desc: "Pemantauan, MLOps, dan tata kelola berkelanjutan untuk menjaga performa, keamanan, dan kepatuhan.",
        },
      ],
      valuesTitle: "Prinsip yang kami pegang",
      values: [
        { t: "Presisi", d: "Setiap keputusan didasari data, bukan asumsi." },
        { t: "Keamanan", d: "Data Anda dilindungi seolah milik kami sendiri." },
        { t: "Transparansi", d: "Tidak ada kotak hitam. Anda memahami setiap sistem." },
        { t: "Akuntabilitas", d: "Kami bertanggung jawab pada ROI, bukan sekadar output." },
      ],
    },
    solutions: {
      heroEyebrow: "Solusi & Layanan",
      heroTitle: "Implementasi AI enterprise, ujung ke ujung.",
      heroSub:
        "Dari strategi hingga tata kelola produksi — kami menangani seluruh siklus hidup solusi AI Anda dengan standar enterprise.",
      detail: [
        {
          tag: "01 / LLM",
          title: "LLM Integration & Generative AI",
          desc: "Kami membangun asisten cerdas dan sistem generatif yang memahami konteks bisnis Anda.",
          points: [
            "Retrieval-Augmented Generation (RAG) di atas basis pengetahuan korporasi",
            "Fine-tuning & prompt engineering domain-spesifik",
            "Deployment privat / on-premise untuk data sensitif",
            "Guardrails, evaluasi, dan mitigasi halusinasi",
          ],
        },
        {
          tag: "02 / ANALYTICS",
          title: "Predictive Analytics & Decision Intelligence",
          desc: "Mengubah data historis menjadi peramalan dan rekomendasi keputusan yang akurat.",
          points: [
            "Peramalan permintaan & optimasi inventori",
            "Deteksi anomali & pencegahan fraud",
            "Segmentasi pelanggan & churn prediction",
            "Dashboard decision intelligence terintegrasi",
          ],
        },
        {
          tag: "03 / VISION",
          title: "Computer Vision",
          desc: "Sistem penglihatan mesin untuk inspeksi, pemantauan, dan otomasi visual.",
          points: [
            "Inspeksi kualitas & deteksi cacat real-time",
            "OCR & ekstraksi dokumen cerdas",
            "Pemantauan keselamatan & keamanan area",
            "Edge deployment berlatensi rendah",
          ],
        },
        {
          tag: "04 / AUTOMATION",
          title: "Intelligent Process Automation",
          desc: "Orkestrasi alur kerja yang menyatukan RPA, AI, dan aturan bisnis.",
          points: [
            "Otomasi dokumen & back-office end-to-end",
            "Integrasi lintas sistem (ERP, CRM, legacy)",
            "Workflow berbasis LLM dengan human-in-the-loop",
            "Middleware integrasi kustom via Laravel",
          ],
        },
      ],
      processTitle: "Model keterlibatan",
      process: [
        { t: "Audit AI", d: "Penilaian kesiapan & pemetaan peluang (2–4 minggu)." },
        { t: "Pilot", d: "Proof-of-value terukur pada satu use case (4–8 minggu)." },
        { t: "Scale", d: "Rollout produksi & integrasi penuh." },
        { t: "Manage", d: "MLOps, monitoring, & optimasi berkelanjutan." },
      ],
      ctaTitle: "Punya use case di benak Anda?",
      ctaBody: "Mari petakan jalur implementasinya bersama tim arsitek kami.",
      ctaBtn: "Mulai Konsultasi",
    },
    portal: {
      heroEyebrow: "Ekosistem Klien Enterprise",
      heroTitle: "Portal aman untuk kolaborasi tanpa kompromi.",
      heroSub:
        "Setiap klien enterprise Litterantara mendapatkan ekosistem terintegrasi untuk dokumen, dashboard, dan komunikasi — dibangun di atas infrastruktur yang Anda kendalikan.",
      systemsTitle: "Komponen ekosistem",
      systems: [
        {
          n: "Laravel Client Portal",
          sub: "",
          d: "Dashboard klien kustom untuk memantau progres proyek, KPI model AI, dan metrik ROI secara real-time. Dilengkapi kontrol akses berbasis peran (RBAC).",
        },
        {
          n: "Nextcloud Secure Storage",
          sub: "",
          d: "Pertukaran dokumen rahasia, NDA, dan modul pelatihan AI dengan enkripsi menyeluruh, audit trail, dan kepatuhan residensi data.",
        },
        {
          n: "RainLoop Webmail",
          sub: "",
          d: "Komunikasi support enterprise yang ringan dan terisolasi, terhubung langsung ke tim delivery dan account management Anda.",
        },
        {
          n: "Mautic Automation",
          sub: "",
          d: "Orkestrasi nurturing dan notifikasi, memastikan setiap interaksi terdokumentasi dan tersinkron dengan tim sales.",
        },
      ],
      securityTitle: "Keamanan berlapis",
      security: [
        { t: "Single Sign-On", d: "Autentikasi terpadu (OIDC) antara Laravel Portal & Nextcloud." },
        { t: "Zero-Trust Access", d: "Verifikasi setiap permintaan, tanpa kepercayaan implisit." },
        { t: "Enkripsi Menyeluruh", d: "TLS in-transit & AES-256 at-rest untuk seluruh dokumen." },
        { t: "Audit Trail", d: "Setiap akses tercatat dan dapat ditinjau untuk kepatuhan." },
      ],
      ctaTitle: "Ingin melihat portal secara langsung?",
      ctaBody: "Kami dapat menyiapkan demo terpandu ekosistem klien enterprise Litterantara.",
      ctaBtn: "Minta Demo Portal",
    },
    caseStudies: {
      heroEyebrow: "Studi Kasus",
      heroTitle: "Dampak nyata, terukur, per industri.",
      heroSub:
        "Bagaimana implementasi AI Litterantara menghasilkan nilai bisnis yang dapat dibuktikan. Berikut simulasi ilustratif berdasarkan pola engagement enterprise nyata.",
      note: "*Angka merupakan simulasi ilustratif berdasarkan pola engagement enterprise, bukan data klien aktual.",
      challengeLabel: "Tantangan",
      solutionLabel: "Solusi Litterantara",
      resultLabel: "Hasil",
      items: [
        {
          sector: "Manufaktur",
          tag: "Computer Vision",
          title: "Inspeksi kualitas real-time pada lini perakitan otomotif",
          challenge:
            "Produsen komponen otomotif menghadapi tingkat cacat lolos QC hingga 6% karena inspeksi manual yang lelah dan tidak konsisten pada lini berkecepatan tinggi, memicu klaim garansi dan recall yang mahal.",
          solution:
            "Kami memasang sistem computer vision berbasis edge dengan model deteksi cacat yang dilatih pada dataset internal. Kamera resolusi tinggi menganalisis setiap unit dalam <120ms, menandai anomali permukaan, dimensi, dan perakitan, terintegrasi langsung ke sistem MES pabrik.",
          results: [
            { metric: "-38%", label: "Cacat lolos QC" },
            { metric: "120ms", label: "Waktu inspeksi/unit" },
            { metric: "3 bln", label: "Balik modal (payback)" },
          ],
          quote:
            "Untuk pertama kalinya kami punya visibilitas kualitas real-time di setiap shift. Cacat yang dulu baru ketahuan di gudang, kini tertangkap di detik pertama.",
          author: "VP Operations, Produsen Komponen Otomotif",
        },
        {
          sector: "Perbankan",
          tag: "LLM Integration",
          title: "Otomasi review dokumen kepatuhan & klaim",
          challenge:
            "Sebuah bank menengah memproses ribuan dokumen klaim dan KYC secara manual, dengan waktu tinjau rata-rata 4 hari dan risiko kesalahan kepatuhan yang tinggi di tengah regulasi yang ketat.",
          solution:
            "Kami membangun asisten berbasis LLM dengan arsitektur RAG di atas basis pengetahuan regulasi internal, berjalan sepenuhnya on-premise. Sistem mengekstrak, memvalidasi, dan meringkas dokumen dengan guardrails audit, menyerahkan kasus ambigu ke reviewer manusia.",
          results: [
            { metric: "4.2x", label: "Kecepatan proses klaim" },
            { metric: "-63%", label: "Backlog dokumen" },
            { metric: "100%", label: "Audit trail terlacak" },
          ],
          quote:
            "Tim kepatuhan kami kini fokus pada keputusan bernilai tinggi, bukan membaca ribuan halaman. Akurasi dan kecepatan naik bersamaan.",
          author: "Head of Compliance, Bank Nasional",
        },
        {
          sector: "Ritel",
          tag: "Predictive Analytics",
          title: "Optimasi inventori multi-gudang berbasis peramalan",
          challenge:
            "Jaringan ritel dengan 40+ gerai dan 5 gudang mengalami stok mati sekaligus kehabisan stok pada SKU laris, karena peramalan permintaan berbasis spreadsheet yang tidak akurat.",
          solution:
            "Kami menerapkan model peramalan permintaan yang menggabungkan data penjualan historis, musiman, promosi, dan sinyal eksternal, terintegrasi ke sistem ERP untuk rekomendasi replenishment otomatis per gudang.",
          results: [
            { metric: "+21%", label: "Akurasi peramalan" },
            { metric: "-27%", label: "Stok mati (dead stock)" },
            { metric: "+14%", label: "Ketersediaan produk" },
          ],
          quote:
            "Kami berhenti menebak. Keputusan pengadaan kini didorong data, dan modal kerja yang terikat di inventori turun signifikan.",
          author: "Supply Chain Director, Jaringan Ritel Nasional",
        },
        {
          sector: "Logistik",
          tag: "Process Automation",
          title: "Otomasi dokumen & orkestrasi alur kerja back-office",
          challenge:
            "Perusahaan logistik memproses ribuan invoice, PO, dan dokumen bea cukai secara manual lintas email dan sistem legacy, menimbulkan keterlambatan pembayaran dan kesalahan entri data.",
          solution:
            "Kami merancang alur otomasi cerdas yang menggabungkan OCR, LLM untuk klasifikasi & ekstraksi, serta middleware Laravel untuk integrasi lintas sistem, dengan human-in-the-loop untuk pengecualian.",
          results: [
            { metric: "-71%", label: "Waktu proses dokumen" },
            { metric: "9.400", label: "Dokumen/bln otomatis" },
            { metric: "-45%", label: "Kesalahan entri" },
          ],
          quote:
            "Proses yang dulu butuh tim penuh kini berjalan hampir otomatis. Pengecualian ditangani manusia, sisanya diselesaikan sistem.",
          author: "COO, Perusahaan Logistik Regional",
        },
      ],
      ctaTitle: "Ingin hasil seperti ini di organisasi Anda?",
      ctaBody: "Mulai dengan audit AI awal untuk memetakan peluang berdampak tertinggi.",
      ctaBtn: "Jadwalkan Audit AI",
    },
    admin: {
      loginTitle: "Portal Admin",
      loginSub: "Masuk untuk mengelola lead konsultasi.",
      email: "Email",
      password: "Password",
      signIn: "Masuk",
      signingIn: "Memproses...",
      loginError: "Email atau password salah.",
      logout: "Keluar",
      dashboardTitle: "Lead Konsultasi",
      dashboardSub: "Kelola dan tindak lanjuti prospek enterprise yang masuk.",
      statTotal: "Total Lead",
      statNew: "Baru",
      statContacted: "Dihubungi",
      statClosed: "Selesai",
      statHigh: "Skor Tinggi",
      filterAll: "Semua",
      colScore: "Skor",
      colName: "Nama",
      colCompany: "Perusahaan",
      colService: "Layanan",
      colStatus: "Status",
      colDate: "Tanggal",
      empty: "Belum ada lead.",
      detailTitle: "Detail Lead",
      statusNew: "Baru",
      statusContacted: "Dihubungi",
      statusClosed: "Selesai",
      updateStatus: "Ubah Status",
      statusUpdated: "Status diperbarui.",
      close: "Tutup",
      tabLeads: "Lead",
      tabInsights: "Insights",
      newArticle: "Artikel Baru",
      createArticle: "Buat Artikel",
      articleCreated: "Artikel dibuat.",
      articleDeleted: "Artikel dihapus.",
      deleteConfirm: "Hapus artikel ini?",
      colTitle: "Judul",
      colCategory: "Kategori",
      colDate: "Tanggal",
      delete: "Hapus",
      save: "Simpan",
      cancel: "Batal",
      fSlug: "Slug (URL)",
      fCategory: "Kategori",
      fCover: "URL Gambar Sampul",
      fAuthor: "Penulis",
      fRead: "Menit Baca",
      fTags: "Tag (pisahkan koma)",
      fTitleId: "Judul (ID)",
      fTitleEn: "Judul (EN)",
      fExcerptId: "Ringkasan (ID)",
      fExcerptEn: "Ringkasan (EN)",
      fBodyId: "Isi (ID)",
      fBodyEn: "Isi (EN)",
      bodyHint: "Gunakan '## ' untuk subjudul, '- ' untuk poin, baris kosong untuk paragraf.",
    },
    insights: {
      heroEyebrow: "Insights & Media",
      heroTitle: "Wawasan AI enterprise dari lini depan.",
      heroSub:
        "Artikel, kerangka kerja, dan perspektif tentang implementasi AI yang aman, terukur, dan berorientasi ROI.",
      all: "Semua",
      searchPlaceholder: "Cari artikel, topik, atau tag…",
      noResults: "Tidak ada artikel yang cocok dengan pencarian Anda.",
      readMore: "Baca selengkapnya",
      back: "Kembali ke Insights",
      minRead: "menit baca",
      by: "Oleh",
      empty: "Belum ada artikel.",
      related: "Artikel lainnya",
      ctaTitle: "Siap menerapkannya di organisasi Anda?",
      ctaBody: "Mulai dengan audit AI awal bersama tim arsitek kami.",
      ctaBtn: "Jadwalkan Audit AI",
    },
    contact: {
      heroEyebrow: "Konsultasi & Audit AI",
      heroTitle: "Mari mulai percakapan yang terukur.",
      heroSub:
        "Isi formulir di bawah untuk menjadwalkan audit AI awal. Tim arsitek kami akan meninjau kebutuhan Anda dan merespons dalam 1×24 jam kerja.",
      infoTitle: "Kanal langsung",
      email: "halo@litterantara.com",
      phone: "+62 21 5000 2025",
      address: "Jakarta Selatan, Indonesia",
      hours: "Senin–Jumat, 09.00–18.00 WIB",
      formTitle: "Jadwalkan Audit AI Awal",
      fields: {
        name: "Nama Lengkap",
        email: "Email Korporasi",
        company: "Nama Perusahaan",
        phone: "Nomor Telepon",
        industry: "Industri",
        size: "Ukuran Perusahaan",
        sizePlaceholder: "Pilih ukuran",
        service: "Layanan yang Diminati",
        servicePlaceholder: "Pilih layanan",
        budget: "Estimasi Anggaran (opsional)",
        budgetPlaceholder: "Pilih rentang",
        message: "Ceritakan tantangan Anda",
        messagePlaceholder: "Tantangan operasional atau use case AI yang ingin Anda selesaikan...",
      },
      sizes: ["1-50", "51-200", "201-1000", "1000+"],
      services: ["LLM Integration", "Predictive Analytics", "Computer Vision", "Process Automation", "Belum yakin"],
      budgets: ["< 100jt", "100-250jt", "250-500jt", "500jt+", "Belum ditentukan"],
      submit: "Kirim Permintaan Audit",
      submitting: "Mengirim...",
      successTitle: "Permintaan terkirim.",
      successBody: "Terima kasih. Tim kami akan menghubungi Anda dalam 1×24 jam kerja.",
      successAgain: "Kirim permintaan lain",
      errorMsg: "Terjadi kesalahan. Silakan coba lagi.",
      required: "wajib diisi",
    },
  },

  en: {
    lang: { switchTo: "ID", current: "EN" },
    nav: {
      home: "Home",
      about: "About",
      solutions: "Solutions",
      cases: "Case Studies",
      insights: "Insights",
      portal: "Client Ecosystem",
      contact: "Consultation",
      cta: "Schedule AI Audit",
    },
    brand: { tagline: "Measured Intelligence, Structured Solutions" },
    footer: {
      blurb:
        "Enterprise-grade AI implementation consultancy & systems integrator. We bridge the complexity of AI with your corporate operational reality.",
      nav: "Navigation",
      ecosystem: "Ecosystem",
      contactTitle: "Get in Touch",
      rights: "All rights reserved.",
      built: "Engineered for enterprises that demand precision.",
    },
    marquee: [
      "LLM Integration",
      "Predictive Analytics",
      "Computer Vision",
      "Process Automation",
      "MLOps Governance",
      "Data Security",
      "Enterprise ROI",
      "Measured Intelligence",
    ],
    home: {
      heroEyebrow: "Enterprise AI Integrator",
      heroLine1: "Measured Intelligence.",
      heroLine2: "Structured Solutions.",
      heroSub:
        "Litterantara designs, builds, and governs enterprise AI implementations that are secure, precise, and driven by real ROI — not experiments, but infrastructure.",
      heroCta: "Schedule an Initial AI Audit",
      heroCta2: "Explore Solutions",
      statClients: "AI Modules Integrated",
      statUptime: "Availability SLA",
      statRoi: "Average Client ROI",
      valueEyebrow: "01 — Why Litterantara",
      valueTitle: "Generic solutions answer trends. Custom solutions answer your business.",
      valueBody:
        "Off-the-shelf AI produces impressive demos that break in enterprise production. We build systems that integrate with your workflows, compliance, and data governance.",
      genericTitle: "Generic AI Solutions",
      generic: [
        "Black-box models with no business context",
        "Fragile integration with legacy systems",
        "No data security or compliance guarantees",
        "Unmeasurable ROI",
      ],
      customTitle: "The Litterantara Approach",
      custom: [
        "AI architecture designed for your domain",
        "Integration middleware into ERP, CRM & data warehouse",
        "Enterprise-grade security & full governance",
        "Measurable KPIs and ROI at every phase",
      ],
      servicesEyebrow: "02 — Core Services",
      servicesTitle: "Four pillars of enterprise AI implementation.",
      services: [
        {
          tag: "LLM",
          title: "LLM Integration",
          desc: "Domain-specific assistants, RAG over corporate knowledge bases, and secure document automation behind your firewall.",
        },
        {
          tag: "ANALYTICS",
          title: "Predictive Analytics",
          desc: "Demand forecasting, anomaly detection, and decision optimization fused with your data warehouse.",
        },
        {
          tag: "VISION",
          title: "Computer Vision",
          desc: "Quality inspection, document OCR, and real-time visual monitoring for industrial and logistics operations.",
        },
        {
          tag: "AUTOMATION",
          title: "Process Automation",
          desc: "Intelligent workflow orchestration combining RPA, LLMs, and business rules for operational efficiency.",
        },
      ],
      securityEyebrow: "03 — Security & Compliance",
      securityTitle: "Infrastructure worthy of your most sensitive data.",
      securityBody:
        "Every deployment is built on zero-trust principles, end-to-end encryption, and data isolation. Your enterprise data never leaves the perimeter you control.",
      badges: ["ISO 27001", "SOC 2 Ready", "GDPR", "PDP Law", "Zero-Trust", "End-to-End Encryption"],
      stackTitle: "Technology Stack",
      stack: [
        { n: "WordPress / SitePad", d: "Marketing & media front-end" },
        { n: "Laravel", d: "Client portal & API middleware" },
        { n: "Nextcloud", d: "Confidential document management" },
        { n: "RainLoop", d: "Enterprise support webmail" },
        { n: "Mautic", d: "Marketing automation & CRM" },
      ],
      caseEyebrow: "04 — Case Studies",
      caseTitle: "Measurable impact at the operational front line.",
      caseNote: "*Illustrative simulations based on enterprise engagement patterns.",
      cases: [
        {
          sector: "Manufacturing",
          metric: "-38%",
          label: "Production defects",
          desc: "Computer vision for real-time quality inspection on assembly lines.",
        },
        {
          sector: "Banking",
          metric: "4.2x",
          label: "Claims processing speed",
          desc: "LLM + RAG for document review and compliance automation.",
        },
        {
          sector: "Retail",
          metric: "+21%",
          label: "Forecast accuracy",
          desc: "Predictive analytics for multi-warehouse inventory optimization.",
        },
      ],
      ctaEyebrow: "Next Step",
      ctaTitle: "Start with a no-obligation AI audit.",
      ctaBody:
        "In 45 minutes, our architects map the highest-impact AI opportunities in your organization along with their ROI estimates.",
      ctaBtn: "Schedule Now",
    },
    about: {
      heroEyebrow: "About Litterantara",
      heroTitle: "We build intelligence that is accountable to outcomes.",
      heroSub:
        "Litterantara stands at the intersection of AI research and corporate operational reality. We translate AI's potential into systems that are secure, measurable, and sustainable.",
      visionTitle: "Vision",
      visionBody:
        "To be Southeast Asia's most trusted enterprise AI integration partner — where every implementation delivers provable business value.",
      missionTitle: "Mission",
      missionBody:
        "To deliver AI solutions that integrate with corporate governance, security, and strategic goals, through a disciplined and transparent methodology.",
      methodEyebrow: "Work Methodology",
      methodTitle: "Four phases. Zero surprises.",
      method: [
        {
          n: "01",
          title: "Discovery",
          desc: "We map your processes, data, and business goals to identify the highest-impact AI opportunities.",
        },
        {
          n: "02",
          title: "Blueprint",
          desc: "Technical architecture, security model, and implementation roadmap designed with clear ROI estimates.",
        },
        {
          n: "03",
          title: "Execution",
          desc: "Iterative development, integration, and deployment with continuous validation at every milestone.",
        },
        {
          n: "04",
          title: "Governance",
          desc: "Monitoring, MLOps, and ongoing governance to sustain performance, security, and compliance.",
        },
      ],
      valuesTitle: "Principles we hold",
      values: [
        { t: "Precision", d: "Every decision is grounded in data, not assumptions." },
        { t: "Security", d: "Your data is protected as if it were our own." },
        { t: "Transparency", d: "No black boxes. You understand every system." },
        { t: "Accountability", d: "We answer to ROI, not just output." },
      ],
    },
    solutions: {
      heroEyebrow: "Solutions & Services",
      heroTitle: "Enterprise AI implementation, end to end.",
      heroSub:
        "From strategy to production governance — we own the entire lifecycle of your AI solution to enterprise standards.",
      detail: [
        {
          tag: "01 / LLM",
          title: "LLM Integration & Generative AI",
          desc: "We build intelligent assistants and generative systems that understand your business context.",
          points: [
            "Retrieval-Augmented Generation (RAG) over corporate knowledge bases",
            "Domain-specific fine-tuning & prompt engineering",
            "Private / on-premise deployment for sensitive data",
            "Guardrails, evaluation, and hallucination mitigation",
          ],
        },
        {
          tag: "02 / ANALYTICS",
          title: "Predictive Analytics & Decision Intelligence",
          desc: "Turning historical data into accurate forecasts and decision recommendations.",
          points: [
            "Demand forecasting & inventory optimization",
            "Anomaly detection & fraud prevention",
            "Customer segmentation & churn prediction",
            "Integrated decision-intelligence dashboards",
          ],
        },
        {
          tag: "03 / VISION",
          title: "Computer Vision",
          desc: "Machine vision systems for inspection, monitoring, and visual automation.",
          points: [
            "Real-time quality inspection & defect detection",
            "Intelligent OCR & document extraction",
            "Safety & area security monitoring",
            "Low-latency edge deployment",
          ],
        },
        {
          tag: "04 / AUTOMATION",
          title: "Intelligent Process Automation",
          desc: "Workflow orchestration uniting RPA, AI, and business rules.",
          points: [
            "End-to-end document & back-office automation",
            "Cross-system integration (ERP, CRM, legacy)",
            "LLM-driven workflows with human-in-the-loop",
            "Custom integration middleware via Laravel",
          ],
        },
      ],
      processTitle: "Engagement model",
      process: [
        { t: "AI Audit", d: "Readiness assessment & opportunity mapping (2–4 weeks)." },
        { t: "Pilot", d: "Measurable proof-of-value on a single use case (4–8 weeks)." },
        { t: "Scale", d: "Production rollout & full integration." },
        { t: "Manage", d: "MLOps, monitoring & continuous optimization." },
      ],
      ctaTitle: "Have a use case in mind?",
      ctaBody: "Let's map the implementation path with our architecture team.",
      ctaBtn: "Start a Consultation",
    },
    portal: {
      heroEyebrow: "Enterprise Client Ecosystem",
      heroTitle: "A secure portal for collaboration without compromise.",
      heroSub:
        "Every Litterantara enterprise client gets an integrated ecosystem for documents, dashboards, and communication — built on infrastructure you control.",
      systemsTitle: "Ecosystem components",
      systems: [
        {
          n: "Laravel Client Portal",
          sub: "",
          d: "Custom client dashboard to monitor project progress, AI model KPIs, and ROI metrics in real time. Role-based access control (RBAC) included.",
        },
        {
          n: "Nextcloud Secure Storage",
          sub: "",
          d: "Exchange of confidential documents, NDAs, and AI training modules with end-to-end encryption, audit trails, and data-residency compliance.",
        },
        {
          n: "RainLoop Webmail",
          sub: "",
          d: "Lightweight, isolated enterprise support communication wired directly to your delivery and account management teams.",
        },
        {
          n: "Mautic Automation",
          sub: "",
          d: "Nurturing and notification orchestration, ensuring every interaction is documented and synced with the sales team.",
        },
      ],
      securityTitle: "Layered security",
      security: [
        { t: "Single Sign-On", d: "Unified authentication (OIDC) between Laravel Portal & Nextcloud." },
        { t: "Zero-Trust Access", d: "Verify every request, with no implicit trust." },
        { t: "End-to-End Encryption", d: "TLS in-transit & AES-256 at-rest for all documents." },
        { t: "Audit Trail", d: "Every access is logged and reviewable for compliance." },
      ],
      ctaTitle: "Want to see the portal live?",
      ctaBody: "We can arrange a guided demo of the Litterantara enterprise client ecosystem.",
      ctaBtn: "Request a Portal Demo",
    },
    caseStudies: {
      heroEyebrow: "Case Studies",
      heroTitle: "Real, measurable impact — by industry.",
      heroSub:
        "How Litterantara's AI implementations deliver provable business value. Below are illustrative simulations based on real enterprise engagement patterns.",
      note: "*Figures are illustrative simulations based on enterprise engagement patterns, not actual client data.",
      challengeLabel: "Challenge",
      solutionLabel: "Litterantara Solution",
      resultLabel: "Results",
      items: [
        {
          sector: "Manufacturing",
          tag: "Computer Vision",
          title: "Real-time quality inspection on automotive assembly lines",
          challenge:
            "An automotive parts manufacturer faced up to 6% QC escape defect rates due to fatigued, inconsistent manual inspection on high-speed lines — triggering costly warranty claims and recalls.",
          solution:
            "We deployed an edge-based computer vision system with a defect-detection model trained on internal datasets. High-resolution cameras analyze each unit in <120ms, flagging surface, dimensional, and assembly anomalies, integrated directly into the plant's MES.",
          results: [
            { metric: "-38%", label: "QC escape defects" },
            { metric: "120ms", label: "Inspection time/unit" },
            { metric: "3 mo", label: "Payback period" },
          ],
          quote:
            "For the first time we had real-time quality visibility across every shift. Defects that once surfaced in the warehouse are now caught in the first second.",
          author: "VP Operations, Automotive Parts Manufacturer",
        },
        {
          sector: "Banking",
          tag: "LLM Integration",
          title: "Automating compliance & claims document review",
          challenge:
            "A mid-size bank processed thousands of claims and KYC documents manually, with a 4-day average review time and high compliance-error risk amid strict regulation.",
          solution:
            "We built an LLM-based assistant with a RAG architecture over an internal regulatory knowledge base, running fully on-premise. It extracts, validates, and summarizes documents with audit guardrails, escalating ambiguous cases to human reviewers.",
          results: [
            { metric: "4.2x", label: "Claims processing speed" },
            { metric: "-63%", label: "Document backlog" },
            { metric: "100%", label: "Traceable audit trail" },
          ],
          quote:
            "Our compliance team now focuses on high-value decisions instead of reading thousands of pages. Accuracy and speed improved together.",
          author: "Head of Compliance, National Bank",
        },
        {
          sector: "Retail",
          tag: "Predictive Analytics",
          title: "Forecast-driven multi-warehouse inventory optimization",
          challenge:
            "A retail chain with 40+ stores and 5 warehouses suffered from both dead stock and stockouts on best-sellers, driven by inaccurate spreadsheet-based demand forecasting.",
          solution:
            "We implemented a demand forecasting model combining historical sales, seasonality, promotions, and external signals — integrated into the ERP for automated per-warehouse replenishment recommendations.",
          results: [
            { metric: "+21%", label: "Forecast accuracy" },
            { metric: "-27%", label: "Dead stock" },
            { metric: "+14%", label: "Product availability" },
          ],
          quote:
            "We stopped guessing. Procurement decisions are now data-driven, and working capital tied up in inventory dropped significantly.",
          author: "Supply Chain Director, National Retail Chain",
        },
        {
          sector: "Logistics",
          tag: "Process Automation",
          title: "Document automation & back-office workflow orchestration",
          challenge:
            "A logistics company processed thousands of invoices, POs, and customs documents manually across email and legacy systems, causing payment delays and data-entry errors.",
          solution:
            "We designed an intelligent automation flow combining OCR, an LLM for classification & extraction, and Laravel middleware for cross-system integration — with human-in-the-loop for exceptions.",
          results: [
            { metric: "-71%", label: "Document processing time" },
            { metric: "9,400", label: "Docs/mo automated" },
            { metric: "-45%", label: "Entry errors" },
          ],
          quote:
            "A process that once required a full team now runs almost automatically. Humans handle exceptions; the system handles the rest.",
          author: "COO, Regional Logistics Company",
        },
      ],
      ctaTitle: "Want results like these in your organization?",
      ctaBody: "Start with an initial AI audit to map the highest-impact opportunities.",
      ctaBtn: "Schedule an AI Audit",
    },
    admin: {
      loginTitle: "Admin Portal",
      loginSub: "Sign in to manage consultation leads.",
      email: "Email",
      password: "Password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      loginError: "Invalid email or password.",
      logout: "Log out",
      dashboardTitle: "Consultation Leads",
      dashboardSub: "Manage and follow up on incoming enterprise prospects.",
      statTotal: "Total Leads",
      statNew: "New",
      statContacted: "Contacted",
      statClosed: "Closed",
      statHigh: "High Score",
      filterAll: "All",
      colScore: "Score",
      colName: "Name",
      colCompany: "Company",
      colService: "Service",
      colStatus: "Status",
      colDate: "Date",
      empty: "No leads yet.",
      detailTitle: "Lead Detail",
      statusNew: "New",
      statusContacted: "Contacted",
      statusClosed: "Closed",
      updateStatus: "Update Status",
      statusUpdated: "Status updated.",
      close: "Close",
      tabLeads: "Leads",
      tabInsights: "Insights",
      newArticle: "New Article",
      createArticle: "Create Article",
      articleCreated: "Article created.",
      articleDeleted: "Article deleted.",
      deleteConfirm: "Delete this article?",
      colTitle: "Title",
      colCategory: "Category",
      colDate: "Date",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      fSlug: "Slug (URL)",
      fCategory: "Category",
      fCover: "Cover Image URL",
      fAuthor: "Author",
      fRead: "Read Minutes",
      fTags: "Tags (comma-separated)",
      fTitleId: "Title (ID)",
      fTitleEn: "Title (EN)",
      fExcerptId: "Excerpt (ID)",
      fExcerptEn: "Excerpt (EN)",
      fBodyId: "Body (ID)",
      fBodyEn: "Body (EN)",
      bodyHint: "Use '## ' for subheadings, '- ' for bullets, blank line for paragraphs.",
    },
    insights: {
      heroEyebrow: "Insights & Media",
      heroTitle: "Enterprise AI insights from the front line.",
      heroSub:
        "Articles, frameworks, and perspectives on secure, measurable, ROI-driven AI implementation.",
      all: "All",
      searchPlaceholder: "Search articles, topics, or tags…",
      noResults: "No articles match your search.",
      readMore: "Read more",
      back: "Back to Insights",
      minRead: "min read",
      by: "By",
      empty: "No articles yet.",
      related: "More articles",
      ctaTitle: "Ready to apply this in your organization?",
      ctaBody: "Start with an initial AI audit with our architecture team.",
      ctaBtn: "Schedule an AI Audit",
    },
    contact: {
      heroEyebrow: "Consultation & AI Audit",
      heroTitle: "Let's start a measured conversation.",
      heroSub:
        "Fill in the form below to schedule an initial AI audit. Our architects will review your needs and respond within one business day.",
      infoTitle: "Direct channels",
      email: "hello@litterantara.com",
      phone: "+62 21 5000 2025",
      address: "South Jakarta, Indonesia",
      hours: "Mon–Fri, 09:00–18:00 WIB",
      formTitle: "Schedule an Initial AI Audit",
      fields: {
        name: "Full Name",
        email: "Corporate Email",
        company: "Company Name",
        phone: "Phone Number",
        industry: "Industry",
        size: "Company Size",
        sizePlaceholder: "Select size",
        service: "Service of Interest",
        servicePlaceholder: "Select a service",
        budget: "Estimated Budget (optional)",
        budgetPlaceholder: "Select a range",
        message: "Tell us about your challenge",
        messagePlaceholder: "The operational challenge or AI use case you want to solve...",
      },
      sizes: ["1-50", "51-200", "201-1000", "1000+"],
      services: ["LLM Integration", "Predictive Analytics", "Computer Vision", "Process Automation", "Not sure yet"],
      budgets: ["< 100M IDR", "100-250M IDR", "250-500M IDR", "500M+ IDR", "To be determined"],
      submit: "Send Audit Request",
      submitting: "Sending...",
      successTitle: "Request sent.",
      successBody: "Thank you. Our team will reach out within one business day.",
      successAgain: "Send another request",
      errorMsg: "Something went wrong. Please try again.",
      required: "is required",
    },
  },
};
